"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleEscrowErrors__factory = void 0;
var _ethers = require("ethers");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const _abi = [{
  inputs: [],
  name: "CallerNotBeneficiary",
  type: "error"
}, {
  inputs: [],
  name: "CallerNotHolder",
  type: "error"
}, {
  inputs: [],
  name: "DualRoleRejectionRequired",
  type: "error"
}, {
  inputs: [],
  name: "EmptyReceivingData",
  type: "error"
}, {
  inputs: [],
  name: "InactiveTitleEscrow",
  type: "error"
}, {
  inputs: [],
  name: "InvalidNominee",
  type: "error"
}, {
  inputs: [{
    internalType: "address",
    name: "registry",
    type: "address"
  }],
  name: "InvalidRegistry",
  type: "error"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "InvalidTokenId",
  type: "error"
}, {
  inputs: [{
    internalType: "address",
    name: "beneficiary",
    type: "address"
  }, {
    internalType: "address",
    name: "holder",
    type: "address"
  }],
  name: "InvalidTokenTransferToZeroAddressOwners",
  type: "error"
}, {
  inputs: [],
  name: "InvalidTransferToZeroAddress",
  type: "error"
}, {
  inputs: [],
  name: "NomineeAlreadyNominated",
  type: "error"
}, {
  inputs: [],
  name: "RecipientAlreadyHolder",
  type: "error"
}, {
  inputs: [],
  name: "RegistryContractPaused",
  type: "error"
}, {
  inputs: [],
  name: "RemarkLengthExceeded",
  type: "error"
}, {
  inputs: [],
  name: "TargetNomineeAlreadyBeneficiary",
  type: "error"
}, {
  inputs: [],
  name: "TitleEscrowNotHoldingToken",
  type: "error"
}, {
  inputs: [],
  name: "TokenNotReturnedToIssuer",
  type: "error"
}];
class TitleEscrowErrors__factory {
  static createInterface() {
    return new _ethers.Interface(_abi);
  }
  static connect(address, runner) {
    return new _ethers.Contract(address, _abi, runner);
  }
}
exports.TitleEscrowErrors__factory = TitleEscrowErrors__factory;
_defineProperty(TitleEscrowErrors__factory, "abi", _abi);